"use client";

import React from "react";
import { ArrowRight, Activity, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EndoskopiHakkinda() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169252" id="tedavi-detayları" className="relative bg-secondary overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute top-0 right-0 -mr-40 -mt-40 w-[600px] h-[600px] bg-[var(--primary)]/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">

          {}
          <div ref={leftRef} className={`lg:col-span-5 flex flex-col items-start transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[var(--primary)]/10 text-[var(--primary)] font-sans font-medium text-sm mb-6 border border-[var(--primary)]/20">
              <Activity className="w-4 h-4" />
              <span>Kusursuz Gülüş Tasarımı</span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl leading-[1.1] font-serif font-bold text-foreground mb-6 tracking-tight">
              Masseter Botoksu <br />
              <span className="text-[var(--primary)]">
                Nasıl
              </span> Uygulanır?
            </h2>

            <p className="text-lg text-muted-foreground font-sans font-normal mb-10 leading-relaxed max-w-xl">
              Diş sıkma botoksu, masseter kasına yapılan mikro enjeksiyonlarla uygulanır. İşlem öncesi bölge uyuşturulur, ardından uzman hekimimiz tarafından belirlenen noktalara botoks enjekte edilerek kasın aşırı gücü dengelenir. Yaklaşık 15 dakikalık bu kısa prosedür sonrası günlük hayatınıza hemen dönebilirsiniz.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="bg-transparent hover:bg-[var(--primary)]/5 text-[var(--primary)] border border-[var(--primary)] shadow-none rounded-sm px-8 h-14 text-base font-semibold transition-all duration-300 group">
                <Link to="/TreatmentsPage">
                  Tedavileri İncele
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>

            <div className="mt-12 flex items-center gap-6 text-sm text-muted-foreground font-sans font-medium">
              <div className="flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-[var(--primary)]" />
                <span>Ağrısız Tedavi</span>
              </div>
              <div className="flex items-center gap-2">
                <Activity className="w-5 h-5 text-[var(--primary)]" />
                <span>Hızlı Sonuç</span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-7 relative transition-all duration-1000 delay-200 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="relative z-10 lg:translate-x-8 lg:scale-105">
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-[var(--primary)]/5 to-transparent rounded-none blur-2xl transform -rotate-3 scale-105" />

              <div className="relative bg-white/10 dark:bg-black/10 backdrop-blur-sm border border-transparent rounded-none p-0 shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/masseter_botox_procedure.png" alt="Diş Sıkma Botoksu Uygulama Süreci" className="w-full h-auto rounded-none object-cover shadow-xl" />

                {}
                <div className="absolute -bottom-6 -left-6 bg-background/90 backdrop-blur-md border border-border rounded-sm p-4 shadow-xl flex items-center gap-4 animate-bounce" style={{
                animationDuration: "4s"
              }}>
                  <div className="w-12 h-12 rounded-full bg-[var(--primary)]/10 flex items-center justify-center">
                    <Activity className="w-6 h-6 text-[var(--primary)]" />
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground font-sans font-medium uppercase tracking-wider">Memnuniyet</p>
                    <p className="text-lg font-bold text-foreground font-serif">%100</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}